module.exports = {
  siteTitle: 'Critical Friend Partnership', // Site title.
  siteTitleAlt: 'Turning ambition & potential into reality', // Alternative site title for SEO.
  siteLogo: '/icons/icon-512x512.png', // Logo used for SEO and manifest.
  siteUrl: 'https://criticalfriendpartnership.co.uk', // Domain of your website without pathPrefix.
  pathPrefix: '', // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter-business/.
  siteDescription: 'Turning ambition & potential into reality', // Website description used for RSS feeds/meta description tag.
  siteRss: '/rss.xml',
  siteFBAppID: '', // FB Application ID for using app insights
  googleTagManagerID: '', // GTM tracking ID.
  disqusShortname: '', // Disqus shortname.
  userName: 'Rufus Denne',
  userTwitter: 'rufusdenne',
  userLocation: 'London',
  userDescription: '',
  copyright: 'Copyright © Critical Friend Partnership 2020. VAT Registration Number: 352 6381 00.', // Copyright string for the footer of the website and RSS feed.
  themeColor: '#111f44', // Used for setting manifest and progress theme colors.
  backgroundColor: '#ffffff', // Used for setting manifest background color.
}
